import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const RoomImageSliderPage = () => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  const images = [
    {
      path: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Bridge over pool',
    },
    {
      path: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Resort entrance',
    },
    {
      path: 'https://images.unsplash.com/photo-1561501900-3701fa6a0864?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Infinity pool',
    },
    {
      path: 'https://images.unsplash.com/photo-1602002418082-a4443e081dd1?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Evening lights pool',
    },
    {
      path: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Spa area',
    },
    {
      path: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80',
      alt: 'Beachfront view',
    },
  ];

  const mainSettings = {
    asNavFor: nav2,
    ref: (slider) => setSlider1(slider),
    arrows: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const thumbSettings = {
    asNavFor: nav1,
    ref: (slider) => setSlider2(slider),
    slidesToShow: 6,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 480, settings: { slidesToShow: 3 } },
    ],
  };

  return (
    <div style={{ maxWidth: '100%', padding: '0 15px', margin: '0 auto' }}>
    <div className="hotel-name">
  <div className="left-part">
    <div className="top d-flex align-items-center justify-content-between">
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <h2>Sea View Hotel</h2>
  <div className="rating">
    <i className="fas fa-star"></i>
    <i className="fas fa-star"></i>
    <i className="fas fa-star"></i>
    <i className="fas fa-star"></i>
    <i className="far fa-star"></i>
  </div>
</div> 
    </div>   
  </div> 
</div>
  <Slider {...mainSettings}>
        {images.map((img, index) => (
          <div key={index}>
            <img
              src={img.path}
              alt={img.alt}
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '530px',
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
          </div>
        ))}
      </Slider>

      {/* Thumbnail Strip */}
      <div style={{ marginTop: '15px' }}>
        <Slider {...thumbSettings}>
          {images.map((img, index) => (
            <div key={index}>
              <img
                src={img.path}
                alt={`Thumbnail ${index + 1}`}
                style={{
                  height: '80px',
                  width: '100%',
                  objectFit: 'cover',
                  borderRadius: '4px',
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default RoomImageSliderPage;
